import { render, staticRenderFns } from "./SearchBox.vue?vue&type=template&id=65e40ede&scoped=true&"
import script from "./SearchBox.vue?vue&type=script&lang=js&"
export * from "./SearchBox.vue?vue&type=script&lang=js&"
import style0 from "./SearchBox.vue?vue&type=style&index=0&id=65e40ede&prod&lang=scss&scoped=true&"
import style1 from "./SearchBox.vue?vue&type=style&index=1&id=65e40ede&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e40ede",
  null
  
)

export default component.exports